import RandingStyle11 from "../../randing/RandingStyle11";

function Randing040({ urlCode, urlCodeSettingId }) {
  const treatments = [
    { value: "a27aa18a-2877-4757-b875-160e4eb8aad7", label: "일반치료" },
    { value: "4185c549-c636-4fb4-b787-1e6c2baa37fe", label: "치아교정" },
    { value: "be0244bd-ec2f-45bb-83e0-d82ae746381c", label: "임플란트" },
  ];
  return (
    <RandingStyle11
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/040/24122701.png`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/040/24122702.jpg`}
      img3Path={`${process.env.REACT_APP_CDN_BASE}/images/040/24122703.jpg`}
      img4Path={`${process.env.REACT_APP_CDN_BASE}/images/040/24122704.jpg`}
      img5Path={`${process.env.REACT_APP_CDN_BASE}/images/040/24122705.jpg`}
      img6Path={`${process.env.REACT_APP_CDN_BASE}/images/040/24122706.gif`}
      img7Path={`${process.env.REACT_APP_CDN_BASE}/images/040/24122707.jpg`}
      img8Path={`${process.env.REACT_APP_CDN_BASE}/images/040/24122708.jpg`}
      img9Path={`${process.env.REACT_APP_CDN_BASE}/images/040/24122709.jpg`}
      // videoUrl={"https://www.youtube.com/embed/DTYAl2wb_Oc"}
      formFieldColor="white"
      privacyMessage="개인정보수집에 동의하시는 분만'신청하기'버튼을 눌러주세요."
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/blue/applyButton.png`}
      companyName="의정부아이엠치과"
      callNumber={"tel:1577-7371"}
      kakaoLink={"https://pf.kakao.com/_VxnbxmK"}
      isCallInsideContactBox={false}
      isKakaoInsideContactBox={false}
      isFixedCallIcon={true}
      isFixedKakaoIcon={true}
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/uijeongbu.jpg`}
      articleOption={true}
      treatments={treatments}
    />
  );
}

export default Randing040;
